import { render, staticRenderFns } from "./FormAnswers.vue?vue&type=template&id=5e6f6928&scoped=true"
import script from "./FormAnswers.vue?vue&type=script&lang=js"
export * from "./FormAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6f6928",
  null
  
)

export default component.exports